import { VoteMethod } from '../types';

const { EARLY_ONLINE_VOTE, EARLY_POSTAL_VOTE } = VoteMethod;

export const isEarlyVote = (voteMethod: VoteMethod): boolean =>
  voteMethod === EARLY_ONLINE_VOTE || voteMethod === EARLY_POSTAL_VOTE;
